import { render, staticRenderFns } from "./InsuredValue.vue?vue&type=template&id=255b4ccf&scoped=true"
import script from "./InsuredValue.vue?vue&type=script&lang=js"
export * from "./InsuredValue.vue?vue&type=script&lang=js"
import style0 from "./InsuredValue.vue?vue&type=style&index=0&id=255b4ccf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b4ccf",
  null
  
)

export default component.exports